<template>
    <div>
        <div class="form-row">
            <div class="form-row__col form-row__col--one-half">
                <form-input
                    name="input_user['firstname']"
                    v-model="inputUser.firstname"
                >
                    {{ trans('global_search.label.input_user.firstname') }}
                </form-input>
            </div>
            <div class="form-row__col form-row__col--one-half">
                <form-input
                    name="input_user['lastname']"
                    v-model="inputUser.lastname"
                >
                    {{ trans('global_search.label.input_user.lastname') }}
                </form-input>
            </div>
        </div>
        <div class="form-row">
            <div class="form-row__col form-row__col--one-half">
                <form-input
                    name="input_user['email']"
                    v-model="inputUser.email"
                >
                    {{ trans('global_search.label.input_user.email') }}
                </form-input>
            </div>
        </div>
        <div class="page-control">
            <div class="page-control__element page-control__element--margin-top"></div>
            <div class="page-control__element page-control__element--margin-top">
                <button @click.prevent="searchUser" class="btn btn--big btn--primary">{{ trans('buttons.search') }}</button>
            </div>
        </div>

        <div class="h:margin-bottom-6">
            <label class="form-section-heading">
                {{ trans('global_search.headline.search_results') }}
            </label>
        </div>

        <div class="form-row">
            <div class="form-row__col">
                <global-search-user-table></global-search-user-table>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from '../eventbus';
    export default {
        data() {
            return {
                inputUser: {
                    firstname: '',
                    lastname: '',
                    email: '',
                },
                tableData: [],
            }
        },

        methods: {
            searchUser() {
                EventBus.$emit('globalSearchUser', this.inputUser);
            },
        },
    }
</script>
